import Service from "../Service";
const resource = "PrfCustomerTemplate/";

export default {
  pagination(obj, requestID, axiosSource) {
    return Service.post(resource + "paginationCodesDetail", obj, {
      params: { requestID },
      cancelToken: axiosSource ? axiosSource.token : undefined,
    });
  },
  save(obj, requestID) {
    return Service.post(resource + "saveCodesDetail", obj, {
      params: { requestID },
    });
  },
};
